module.exports = __webpack_public_path__ + "media/andenes/nivelador_fosa-c69e091f.webp";